import { render } from "./DashboardParts.vue?vue&type=template&id=42f37d8d&scoped=true"
import script from "./DashboardParts.vue?vue&type=script&lang=js"
export * from "./DashboardParts.vue?vue&type=script&lang=js"

import "./DashboardParts.vue?vue&type=style&index=0&id=42f37d8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f37d8d"]])

export default __exports__